import { IconCheck, IconPlayerPlayFilled } from "@tabler/icons-react";
import Text from "../UI/Text";
import Status from "../UI/Status";
import { formatDuration, type TutorialVideo } from "./videoTutorials";
import styles from "./TutorialVideoList.module.css";

interface TutorialVideoListProps {
  videos: TutorialVideo[];
  seenIds: string[];
  currentId?: string;
  onSelect: (video: TutorialVideo) => void;
}

export default function TutorialVideoList({
  videos,
  seenIds,
  currentId,
  onSelect,
}: TutorialVideoListProps) {
  return (
    <div className={styles.list}>
      {videos.map((video) => {
        const isCurrent = video.id === currentId;
        const isSeen = seenIds.includes(video.id);
        return (
          <button
            key={video.id}
            type="button"
            className={styles.item}
            onClick={() => onSelect(video)}
          >
            <span className={styles.thumb}>
              <IconPlayerPlayFilled size={14} />
              <Text as="span" variant="deci" weight="bold" color="white">
                {formatDuration(video.duration)}
              </Text>
            </span>
            <span className={styles.content}>
              <Text as="span" weight="medium">
                {video.title}
              </Text>
              {isCurrent ? (
                <Status as="span" color="info" text="En cours" />
              ) : isSeen ? (
                <Status as="span" color="success" icon={IconCheck} text="Vu" />
              ) : (
                <Status as="span" color="orange" text="Nouveau" />
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
